import { Mqtt_Topics_institutionChanges } from "../RAWMap.Models/Api.js";
import { singleton } from "../fable_modules/fable-library-js.4.19.3/List.js";
import { Msg } from "./InstitutionTypes.js";

export function subscribe(uid) {
    return [singleton(Mqtt_Topics_institutionChanges(uid)), (Item) => (new Msg(20, [Item]))];
}

